import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || null,
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' }
});

let _token = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_TOKEN) || null;

export function setToken (token) {
  _token = token;
}

export function setBaseUrl (url) {
  api.defaults.baseURL = url || null;
}

api.interceptors.request.use(config => {
  if (_token) {
    config.headers['Authorization'] = /^bearer\s+/i.test(_token) ? _token : `bearer ${_token}`;
  }
  return config;
});

export default api;
